var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative mx-4 px-4 px-sm-2"},[_c('Proposition65WarningSymbol',{attrs:{"left":_vm.xs ? 0 : -10,"top":4}}),_c('p',{staticClass:"dont-break-out pt-1 pt-sm-0",class:_vm.xs ? 'font-size-xs' : '',domProps:{"innerHTML":_vm._s(_vm.storeInfo.alcohol_text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }